import { SET_NOVA_SOLICITACAO_REQUERIMENTO, SET_PAGAMENTO_SELECIONADO } from '../actions/actionTypes';

const initialState = {
  novaSolicitacaoAdicionada: false,
  pagamentoSelecionado: {
    id: 0,
    nossoNumero: '',
    situacao: {
      id: 0,
      text: ''
    },
    dataCriacao: '',
    dataPagamento: '',
    dataDeclaracaoPagamento: ''
  }
};

export const pagamentoReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_NOVA_SOLICITACAO_REQUERIMENTO:
      return {
        ...state,
        novaSolicitacaoAdicionada: action.newValue
      };

    case SET_PAGAMENTO_SELECIONADO:
      return {
        ...state,
        pagamentoSelecionado: action.newValue
      };

    default:
      return state;
  }
};
